import $ from 'jquery';
import Modal from './modal'
import select2 from './vendor/select2'
import select2_i18n_ru from './vendor/select2-i18n-ru'
import jqueryMask from './vendor/jquery.mask'

const bepartner = function() {

    const showFieldError = function (fieldName, errorMessage) {
        const input = $('input[name=' + fieldName + ']');
        input.closest('.partner-page__form__field').addClass('error');
        input.after('<div class="input-error">' + errorMessage + '</div>');
    }

    const cleanFieldError = function (fieldName) {
        const input = $('input[name=' + fieldName + ']');
        input.closest('.partner-page__form__field').removeClass('error');
        input.next('.input-error').remove();
    }

    if (window.partner_form_errors) {
        let firstErrorField = null;
        let gRecaptchaError = false;

        for (let field in window.partner_form_errors) {
            if (field === 'g-recaptcha-response') {
                gRecaptchaError = true;
                continue;
            }

            let input;
            if (field === 'product_group' || field === 'business_direction') {
                input = $('input[name="' + field + '[]"]');
            } else if (field === 'assembling_pc' || field === 'assembling_server') {
                input = $('select[name=' + field + ']');
            } else {
                input = $('input[name=' + field + ']');
            }

            if (input) {
                if (!firstErrorField) {
                    firstErrorField = input;
                }
                if (field === 'product_group' || field === 'business_direction') {
                    input.closest('.partner-page__form__group').addClass('error');
                    input.closest('.partner-page__form__group').children().first().after('<div class="input-error">' + window.partner_form_errors[field] + '</div>');
                } else {
                    input.closest('.partner-page__form__field').addClass('error');
                    if (field === 'assembling_pc' || field === 'assembling_server') { // Выбираем следующий элемент т.к. у нас создаётся selectize динамически
                        input.next().after('<div class="input-error">' + window.partner_form_errors[field] + '</div>');
                    } else {
                        input.after('<div class="input-error">' + window.partner_form_errors[field] + '</div>');
                    }
                }
            }
        }

        if (firstErrorField) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.error').first().offset().top - 20
            }, 400);
        } else if (gRecaptchaError) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.g-recaptcha').first().offset().top - 20
            }, 400);
        }
    }

    let emptyContactsModal = new Modal({
        header: false,
        content: 'Чтобы найти компанию, необходимо заполнить блок "Личная информация"',
        buttons: [{
            text: 'Закрыть',
            value: true,
            attr: {
                'class': 'button button--primary',
                'data-dismiss': 'modal'
            }
        }]
    });

    const switchFindCompanyButton = function () {
        if ($('#inn').val() && (isInnForIpOrUnp() || $('#kpp').val())) {
            $('#find_company').attr('disabled') && $('#find_company').removeAttr('disabled');
        } else {
            !$('#find_company').attr('disabled') && $('#find_company').attr('disabled', 'disabled');
        }
    };

    const toggleProcessPersonalDataAgree = function () {
        if ($('#process_personal_data_agree').is(':checked')) {
            $('button[type="submit"]').removeAttr('disabled');
        } else {
            $('button[type="submit"]').attr('disabled', 'disabled');
        }
    }

    const fieldsNotRequiredForIp = ['kpp', 'address', 'postcode'];
    let lastInnForIp = false;

    const isInnForIpOrUnp = function () { // ИНН для ИП или Белорусский УНП
        return $('#inn').val().replace(/\s+/g, '').length === 12 || $('#inn').val().replace(/\s+/g, '').length === 9;
    }

    const switchRequiredLabelsForIp = function (disable) {
        fieldsNotRequiredForIp.forEach(function(elementId) {
           if (disable) {
               $('label[for=' +  elementId  + ']').removeAttr('data-required');
           } else {
               $('label[for=' +  elementId  + ']').attr('data-required', true);
           }
        });
    }

    const switchFindByInnButtonText = function (currentInnForIp) {
        if (currentInnForIp) {
            $('.load-more-button__label').text('Найти по ИНН');
        } else {
            $('.load-more-button__label').text('Найти по ИНН и КПП');
        }
    }

    const switchDisableKppField = function (disable) {
        if (disable) {
            $('#kpp').val('');
            $('#kpp').attr('disabled', 'disabled');
        } else {
            $('#kpp').removeAttr('disabled');
        }
    }

    const switchEnableAddressFields = function (currentInnForIp) {
        if (currentInnForIp) {
            $('#region').removeAttr('readonly');
            $('#city').removeAttr('readonly');
            $('#address').removeAttr('readonly');
            $('#postcode').removeAttr('readonly');
        } else {
            $('#region').prop('readonly', true);
            $('#city').prop('readonly', true);
            $('#address').prop('readonly', true);
            $('#postcode').prop('readonly', true);
        }
    }

    const switchEnableAddressFieldsIfLe2Empty = function(isAjaxComplete, region, city, postcode) {
        const currentInnForIp = isInnForIpOrUnp();

        if (!currentInnForIp) {
            if (isAjaxComplete) {
                if (!region) {
                    $('#region').removeAttr('readonly');
                }
                if (!city) {
                    $('#city').removeAttr('readonly');
                }
                if (!postcode) {
                    $('#postcode').removeAttr('readonly');
                }
            } else {
                $('#region').prop('readonly', true);
                $('#city').prop('readonly', true);
                $('#postcode').prop('readonly', true);
            }
        }
    }

    const updateFormForIp = function () {
        let currentInnForIp = isInnForIpOrUnp();

        if (currentInnForIp !== lastInnForIp) {
            lastInnForIp = currentInnForIp;
            switchFindByInnButtonText(currentInnForIp);
            switchRequiredLabelsForIp(currentInnForIp);
            switchDisableKppField(currentInnForIp);
            switchEnableAddressFields(currentInnForIp);
        }
    }

    const toggleSecondContact = function () {
        const toggle_display = $('#second_contact').val() === 'true' ? 'flex' : 'none';
        $('#second_contact').closest('.partner-page__form__group').children('.partner-page__form__group__field-wrapper').css('display', toggle_display);
    };

    if ($('#partner_form').length) {
        switchFindCompanyButton();
        updateFormForIp();
        toggleSecondContact();
        toggleProcessPersonalDataAgree();
    }

    $('body').on('click', 'a.find_company', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const requiredFieldsIds = ['surname', 'firstname', 'position', 'work_phone', 'email'];

        for (const fieldId of requiredFieldsIds) {
            if (!$('#' + fieldId).val()) {
                emptyContactsModal.show();
                return;
            }

            cleanFieldError(fieldId);
        }

        $('#find_company_error').hide();
        $('#find_company_error').text('Компания не найдена');
        $('#find_company').addClass('_disabled');

        $('#company').val('');
        if (!isInnForIpOrUnp()) {
            $('#postcode').val('');
            $('#region').val('');
            $('#city').val('');
            $('#address').val('');
        }

        switchEnableAddressFieldsIfLe2Empty();

        $.ajax({
            url: $('#find_company').data('action'),
            type: 'post',
            data: {
                'inn': $('#inn').val(),
                'kpp': $('#kpp').val(),
                'surname': $('#surname').val(),
                'firstname': $('#firstname').val(),
                'middlename': $('#firstname').val(),
                'position': $('#position').val(),
                'work_phone': $('#work_phone').val(),
                'email': $('#email').val()
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $('#find_company').removeClass('_disabled');

                if (!response || !response['organization']) {
                    if (response['error']) {
                        $('#find_company_error').text(response['error']);
                    }

                    $('#find_company_error').show('fast');
                    $('#find_company_error').css('display','inline-block');

                    return;
                }

                let organization = response['organization']

                if (!organization['shortName']) {
                    $('#find_company_error').show('fast');
                    $('#find_company_error').css('display','inline-block');

                    return;
                }

                $('#company').val(organization['shortName']).trigger('input');
                $('#postcode').val(organization['postcode']).trigger('input');
                $('#region').val(organization['region']).trigger('input');
                $('#city').val(organization['city']).trigger('input');
                $('#address').val(organization['streetAddress']).trigger('input');
                $('#country').val(organization['country']);
                $('#district').val(organization['district']);

                switchEnableAddressFieldsIfLe2Empty(true, organization['region'], organization['city'], organization['postcode']);
            },
            error: function (error) {
                $('#find_company').removeClass('_disabled');

                if (error['responseJSON'] && error['responseJSON']['errors']) {
                    const response = error['responseJSON'];

                    for (const fieldId of requiredFieldsIds) {
                        if (fieldId in response['errors']) {
                            showFieldError(fieldId, response['errors'][fieldId]);
                        }
                    }
                } else {
                    $('#find_company_error').show('fast');
                    $('#find_company_error').css('display','inline-block');
                }
            }
        })
    });

    $('body').on('click', '#second_contact_button', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const second_contact = $('#second_contact');
        const toggle_value = second_contact.val() === 'true' ? 'false' : 'true';

        second_contact.val(toggle_value);
        toggleSecondContact();
    });

    $('#partner_form').on('input change', 'input, select, textarea', function(e) {
        if (e.target.name === 'g-recaptcha-response') {
            return;
        }

        if (e.target.name === 'process_personal_data_agree') {
            toggleProcessPersonalDataAgree();
            return;
        }

        if (e.target.name === 'inn') {
            updateFormForIp();
        }

        if (e.target.name === 'inn' || e.target.name === 'kpp') {
            $('#find_company_error').hide();
            switchFindCompanyButton();
        }

        let wrapper;
        if (e.target.name === 'product_group[]' || e.target.name === 'business_direction[]') {
            wrapper = $(e.target).closest('.partner-page__form__group')
        } else {
            wrapper = $(e.target).closest('.partner-page__form__field');
        }

        if (wrapper && wrapper.hasClass('error')) {
            wrapper.removeClass('error')
        }
    });

    const tcm_csp_get_address = function () {
        return $('#postcode').val() + ', ' + $('#city').val() + ', ' + $('#address').val();
    };

    const tcm_csp_company = function (enable) {
        if (enable) {
            $('#company').change(function() {
                $('#tcm_csp_company').val($(this).val());
            });
            $('#address').change(function() {
                $('#tcm_csp_address').val(tcm_csp_get_address());
            });
            $('#inn').change(function() {
                $('#tcm_csp_inn').val($(this).val());
            });
            $('#tcm_csp_company').val($('#company').val());
            $('#tcm_csp_address').val(tcm_csp_get_address());
            $('#tcm_csp_inn').val($('#inn').val());

            $('#tcm_csp_company').prop('readonly', true);
            $('#tcm_csp_address').prop('readonly', true);
            $('#tcm_csp_inn').prop('readonly', true);
        } else {
            $('#company').off('change');

            $('#postcode').off('change');
            $('#city').off('change');
            $('#address').off("change");

            $('#inn').off('change');

            $('#tcm_csp_company').prop('readonly', false);
            $('#tcm_csp_address').prop('readonly', false);
            $('#tcm_csp_inn').prop('readonly', false);

            // $('#tcm_csp_company').val('');
            // $('#tcm_csp_address').val('');
            // $('#tcm_csp_inn').val('');
        }
    };

    const tcm_csp_person = function (enable) {
        if (enable) {
            $('#surname').change(function() {
                $('#tcm_csp_surname').val($(this).val());
            });
            $('#firstname').change(function() {
                $('#tcm_csp_firstname').val($(this).val());
            });
            $('#email').change(function() {
                $('#tcm_csp_email').val($(this).val());
            });
            $('#tcm_csp_surname').val($('#surname').val());
            $('#tcm_csp_firstname').val($('#firstname').val());
            $('#tcm_csp_email').val($('#email').val());

            $('#tcm_csp_surname').prop('readonly', true);
            $('#tcm_csp_firstname').prop('readonly', true);
            $('#tcm_csp_email').prop('readonly', true);
        } else {
            $('#surname').off('change');
            $('#firstname').off('change');
            $('#email').off('change');

            $("#tcm_csp_surname").prop('readonly', false);
            $("#tcm_csp_firstname").prop('readonly', false);
            $("#tcm_csp_email").prop('readonly', false);
            // $('#tcm_csp_surname').val('');
            // $('#tcm_csp_firstname').val('');
            // $('#tcm_csp_email').val('');
        }
    };

    const tcm_csp_toggle = function (enable) {
        if (enable) {
            $('[id^=tcm_csp]').prop('disabled', false);
            $('#tcm_csp_same_company').change(function() {
                tcm_csp_company(this.checked);
            });
            $('#tcm_csp_same_person').change(function() {
                tcm_csp_person(this.checked);
            });
            tcm_csp_company($('#tcm_csp_same_company').is(':checked'));
            tcm_csp_person($('#tcm_csp_same_person').is(':checked'));
        } else {
            $('#tcm_csp_same_company').off('change');
            $('#tcm_csp_same_person').off('change');
            tcm_csp_company(false);
            tcm_csp_person(false);
            $('[id^=tcm_csp]').prop('disabled', true);
        }
    };

    const tcm_order_csp_toggle = function (enable) {
        if(enable)
        {
            $('#tcm_order_content').show();
            tcm_csp_toggle(true);
        } else {
            $('#tcm_order_content').hide();
            tcm_csp_toggle(false);
        }
    };

    if($('#tcm_order_content').length) {
        $('input[type=radio][name=tcm_order_csp]').change(function () {
            tcm_order_csp_toggle(this.checked && this.value === 'yes');
        });
        tcm_order_csp_toggle($('input[type=radio][name=tcm_order_csp]:checked').val() === 'yes');
    }

    $(() => {
        select2($);
        select2_i18n_ru($);
        jqueryMask($)

        function forceAlpha() {
            var $input = $(this);
            $input.val($input.val().replace(/[^a-zа-я ]+/gi, ''));
        }

        const alphaFieldsIds = ['surname', 'firstname', 'middlename'];
        for (const alphaFieldId of alphaFieldsIds) {
            if($('#' + alphaFieldId).length) {
                $('body').on('propertychange input', 'input[name="' + alphaFieldId + '"]', forceAlpha);
            }
        }

        const phoneFieldsIds = ['mobile_phone', 'work_phone', 'office_phone', 'second_mobile_phone', 'second_work_phone'];
        for (const phoneFieldId of phoneFieldsIds) {
            if($('#' + phoneFieldId).length) {
                $('#' + phoneFieldId).mask("+0 (000) 000-00-00", {placeholder: "+7 (000) 000-00-00"});
            }
        }

        if($('#position').length) {
            $('#position').select2({
                language: 'ru',
                theme: 'flat',
                arrowHtml: '<svg class="select2-arrow"><use xlink:href="#select_arrow" x="0" y="0"></use></svg>'
            });
        }
    });
};

export default bepartner;
